import { map } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/gdk-base';
export function createParameterService(api) {
    return {
        exportFinance() {
            return api.fetch(ADMIN_API.POST_EXPORT_FINANCE);
        },
        issueAuthenticator() {
            return api.fetch(ADMIN_API.GET_ISSUE_PARAMETER_AUTHENTICATOR);
        },
        validateAuthenticator(code) {
            return api.fetch(ADMIN_API.POST_VALIDATE_PARAMETER_AUTHENTICATOR, { data: { code } });
        },
        deleteAuthenticator(code) {
            return api.fetch(ADMIN_API.POST_DELETE_PARAMETER_AUTHENTICATOR, { data: { code } });
        },
        getAuthenticatorStatus() {
            return api.fetch(ADMIN_API.GET_PARAMETER_AUTHENTICATOR_STATUS);
        },
        getIpWhitelistList(data) {
            return api.fetch(ADMIN_API.GET_IP_WHITELIST_LIST, { data }).pipe(map((res) => res.map((item) => convertUnixToDate(item, 'created_at'))));
        },
        createIpWhitelist(data) {
            return api.fetch(ADMIN_API.POST_IP_WHITELIST, { data });
        },
        deleteIpWhitelist(id) {
            return api.fetch(ADMIN_API.DELETE_IP_WHITELIST, { config: { urlParams: { id } } });
        },
        getDomainList() {
            return api.fetch(ADMIN_API.GET_DOMAIN_LIST);
        },
        updateDomain(data) {
            return api.fetch(ADMIN_API.PUT_DOMAIN, { data });
        },
        getPromoDomainList() {
            return api.fetch(ADMIN_API.GET_PROMO_DOMAIN_LIST);
        },
        updatePromoDomain(data) {
            return api.fetch(ADMIN_API.PUT_PROMO_DOMAIN, { data });
        }
    };
}
//# sourceMappingURL=ParameterService.js.map